import { Component, OnInit } from '@angular/core';
import {Router,Event} from '@angular/router';
import { DataService } from 'src/app/shared/services/data.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  currentYear: number = new Date().getFullYear();
  currentRoute:any;
  isLoggedIn:boolean = false;
  logoPath:string = '/assets/img/white-new-logo.png';

  constructor(private router: Router,private dataService: DataService) {
  	this.router.events.subscribe((event: Event) => {
       this.currentRoute = window.location.pathname;
     });


  }

  ngOnInit(): void {
    this.checkIfalreadyLoggedIn();
    this.dataService.dealerlogo.subscribe(logo => {
      this.logoPath = logo;
    })
  }


  checkIfalreadyLoggedIn() {
    const token = localStorage.getItem('ts_vendor_access_token');
    if(token) {
      this.isLoggedIn = true;
    } else {
      this.isLoggedIn = false;
    }
  }

}
